<template>
  <div>
    <v-toolbar class="primary" dark>
      <v-toolbar-title>Build Your {{ selectedTemplate.type }} Task List</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat icon @click="$emit('closeDialog')"><v-icon>close</v-icon></v-btn>
    </v-toolbar>
    <v-toolbar dark class="secondary">
      <v-layout align-center fill-height>
        <v-flex xs2 v-if="!projectStartDateConfirmed">
          <div>Is the {{ selectedTemplate.type }} Start Date Correct? </div>
        </v-flex>
        <v-flex xs1>
          <v-btn @click="showStartDateFilter = true" flat icon><v-icon large>event</v-icon></v-btn>
        </v-flex>
        <v-flex xs2 mt-4>
          <v-text-field @click="showStartDateFilter = true" v-model="projectStartDate" label="Start Date" readonly></v-text-field>
        </v-flex>
        <v-flex ml-3 v-if="projectStartDate && !projectStartDateConfirmed">
          <v-btn class="primary" @click="projectStartDateConfirmed = true">Continue</v-btn>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-container class="white">
      <v-alert :value="getAllDoubleBookedVendors" type="warning">*Note: You have double booked vendor tasks. Highlight over RED vendors to see </v-alert>
        <v-data-table v-if="projectStartDateConfirmed && !reorderRefresh" :headers="headers" :items="templateTasks" item-key="taskId" hide-actions class="elevation-1" :pagination.sync="sort">
          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-left body-2 font-weight-bold" style="padding-left: 1"> <!-- Task -->
                <span>{{ props.item.name }}</span>
              </td>
              <td class="text-xs-left body-2 font-weight-bold" style="padding-left: 1"> <!-- Phase -->
                <span>{{ props.item.phase }}</span>
              </td>
              <td class="text-xs-left" style="padding-left: 1"> <!-- Task Starts -->
                <v-edit-dialog>
                  <!-- <template v-slot:input> v-slot:input -->
                    <v-select @change="props.item.order = returnDaysDue(props); refreshOrder()" v-model="props.item.after_task" :items="taskStartsDropdown" class="caption"></v-select>
                  <!-- </template> -->
                </v-edit-dialog>
              </td>
              <td class="text-xs-center"> <!-- Days Until Due -->
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field v-model="props.item.days_due" label="Edit" single-line class="text-xs-center" @blur="props.item.order = returnDaysDue(props)"></v-text-field>
                  </v-flex>
                </v-layout>
              </td>
              <td style="cursor:pointer" class="text-xs-left"> <!-- if N/A -->
                <v-checkbox :disabled="!props.item.if_na"
                  v-model="props.item.not_applicable"
                ></v-checkbox>
              </td>
              <td> <!-- Vendor -->
                <!-- <v-btn @click="selectedTask = props.item; vendorSearch = true" style="width: 90%" outline>{{ props.item.vendorName }}</v-btn> -->
                <v-btn :color="props.item.doubleBookedVendorError ? 'red' : 'black'" :outline="props.item.doubleBookedVendorError ? false : true" v-if="props.item.vendorName" @click="selectedTask = props.item; vendorSearch = true" style="width: 90%" :style="props.item.vendorName.length > 35 ? 'font-size:6px' : props.item.vendorName.length > 30 ? 'font-size:8px' : props.item.vendorName.length > 25 ? 'font-size:10px' : 'font-size:12px'" wrap>{{props.item.vendorName}}<v-btn v-if="props.item.vendorName && props.item.vendorName !== 'NO VENDOR ASSIGNED'" small icon light @click="selectedTask = props.item; removeVendor(props)"><v-icon>clear</v-icon></v-btn></v-btn>
                <!-- <v-btn icon color="error"><v-icon small>alert-circle</v-icon></v-btn> -->
              </td>
              <td> <!-- Assigned Users -->
                <v-layout>
                  <div v-if="props.item.assignedUsers && props.item.assignedUsers.length > 0">
                    <div v-for="(user, i) in props.item.assignedUsers" :key="i">
                      <v-badge overlap color="grey" class="ml-2">
                        <span @click="props.item.assignedUsers.splice(i,1)" style="cursor:pointer" slot="badge">X</span>
                          <v-avatar>
                            <v-tooltip top>
                              <avatar slot="activator" :username="user.first_name + ' ' + user.last_name" :src="user.avatar ? user.avatar : undefined"></avatar>{{ user.first_name + ' ' + user.last_name }}
                            </v-tooltip>
                          </v-avatar>
                      </v-badge>
                    </div>
                  </div>
                  <v-menu transition="slide-x-transition" bottom right>
                  <v-btn light flat icon slot="activator"><v-icon>person_add</v-icon></v-btn>
                    <v-list>
                      <v-list-tile v-for="(user, i) in userList" :key="i" @click="props.item.assignedUsers.push(user)">
                        <v-avatar class="mr-3">
                          <avatar :size="36" :username="user.first_name + ' ' + user.last_name" :src="user.avatar ? user.avatar : undefined"></avatar>
                        </v-avatar>
                        <v-list-tile-title class="font-weight-strong">{{ user.first_name + ' ' + user.last_name }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-layout>
              </td>
            </tr>
            <!-- Identifies if the vendor is double booked on another project on the same due date -->
            <tr v-if="props.item.doubleBookedVendorError">
              <td colspan="7">
                <v-alert :value="true" type="warning">*Note: This Vendor is already booked for the same date range:
                  <v-list class=" warning white--text" v-for="(vendors, index) in props.item.doubleBookedVendorError" :key="index">
                    Project: {{ vendors.projectName }} | Task: {{ vendors.taskName }} | Due Date: {{ vendors.dueDate.seconds | moment("dddd, MMMM Do YYYY") }}
                  </v-list>
                </v-alert>
              </td>
            </tr>
          </template>
            <!-- End: Identifies if the vendor is double booked on another project on the same due date -->
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-btn :disabled="disableButton" v-if="projectStartDateConfirmed" color="primary" @click="createTaskList">Save and Create Task List</v-btn>
          <v-btn :disabled="disableButton" color="secondary" @click="$emit('closeDialog')">Cancel</v-btn>
          <span v-if="disableButton">Loading Tasks...</span>
        </div>
    </v-container>
  <!-- Vendor Search Dialog Box -->
    <v-dialog v-if="vendorSearch" v-model="vendorSearch" class="primary" width="600px" height="400px">
      <vendor-search v-if="vendorSearch" :taskTemplate="true" :task="selectedTask" :project="project" @closeDialog="vendorSearch = false" @emittedVendor="emittedVendor" />
    </v-dialog>
  <!-- End: Vendor Search Dialog Box -->
  <!-- Project Start Dialog Box -->
    <v-dialog v-model="showStartDateFilter" width="290px">
      <v-date-picker v-model="projectStartDate" @input="showStartDateFilter = false"></v-date-picker>
    </v-dialog>
  <!-- End: Project Start Dialog Box -->
  </div>
</template>

<script>
import Avatar from 'vue-avatar'
import _ from 'lodash'
import VendorSearch from '../vendors/VendorSearch'

export default {
  props: ['project', 'taskTemplate', 'movingToConstruction'],
  mounted () {
    this.getTemplateTasks()
    this.$store.commit('getAllDoubleBookedVendors', null)
  },
  data () {
    return {
      reorderRefresh: false,
      disableButton: false,
      projectStartDate: null,
      projectStartDateConfirmed: false,
      showStartDateFilter: false,
      dataEntry: null,
      showUpdateDaysDialog: false,
      updateDaysDue: null,
      sort: {
        sortBy: 'order',
        rowsPerPage: -1
      },
      selectedTask: null,
      vendorSearch: false,
      templateTasks: [],
      headers: [
        { text: 'Task', value: 'name', sortable: false, class: ['text-xs-left'], width: '25%' },
        { text: 'Phase', value: 'phase', sortable: false, width: '25%' },
        { text: 'Task Starts', value: 'task_starts', sortable: false, width: '25%' },
        { text: 'Days Until Due', value: 'days_due', sortable: false, width: '3%' },
        { text: 'N/A', value: 'if_na', sortable: false, width: '3%' },
        { text: 'Vendor', value: 'vendor', sortable: false, width: '20%' },
        { text: 'Assigned', value: 'assigned', sortable: false, width: '20%' }
      ]
    }
  },
  computed: {
    getAllDoubleBookedVendors () {
      const doubleBooked = this.$store.getters.getAllDoubleBookedVendors
      if (doubleBooked && this.templateTasks && this.templateTasks.length > 0) {
        const taskKeys = Object.keys(doubleBooked)
        taskKeys.forEach(task => {
          if (doubleBooked[task]) {
            this.templateTasks[task] = { ...this.templateTasks[task], doubleBookedVendorError: doubleBooked[task] }
            this.refreshOrder()
          }
        })
        return doubleBooked
      } else {
        return null
      }
    },
    userList () {
      return _.orderBy(this.$store.getters.userList, 'first_name')
    },
    taskStartsDropdown () {
      let taskList = [{ text: 'From Start Date', value: '' }]
      const afterTasks = this.templateTasks.map(m => ({ text: 'After: ' + m.name, value: m.taskId }))
      return _.uniqWith(taskList.concat(afterTasks), _.isEqual)
    },
    selectedTemplate () {
      const templates = this.$store.getters.getTemplates
      const template = templates.filter(f => f.id === this.taskTemplate)[0]
      if (template.type === 'Pre-Construction') {
        this.projectStartDate = this.$moment(this.project.start_date.seconds * 1000).format('YYYY-MM-DD')
      }
      return template
    }
  },
  methods: {
    refreshOrder () { // Needed to refresh the list to correct values
      this.vendorSearch = false
      this.reorderRefresh = true
      setTimeout(() => {
        this.reorderRefresh = false
      }, 500)
    },
    checkDoubleBooked (taskIndex, vendor, newOrder) {
      const startDate = new Date(this.projectStartDate)
      const daysDue = this.templateTasks[taskIndex].order
      let dueDate = new Date()
      if (newOrder) {
        dueDate = new Date(dueDate.setDate(startDate.getDate() + newOrder))
      } else {
        dueDate = new Date(dueDate.setDate(startDate.getDate() + parseInt(daysDue)))
      }
      this.$store.dispatch('checkVendorDoubleBooked', { taskId: taskIndex, isDoubleBooked: false, vendorId: vendor.id, dueDate: dueDate, isTemplateTask: true })
    },
    closeDialog () {
      if (this.movingToConstruction) {
        this.$emit('updateConstructionStatus')
      }
      this.$emit('closeDialog')
      this.$emit('loadedTasks')
    },
    createTaskList () {
      this.disableButton = true
      let taskList = []
      // Process Tasks WITHOUT a Dependancy
      this.templateTasks.forEach(task => {
        const docTimestamp = String((new Date()).getTime()) + '-' + Math.floor(Math.random() * 10000) + Math.floor(Math.random() * 10000)
        if (task.after_task === '' || !task.after_task) {
          taskList.push({ ...task, id: docTimestamp, after_task: null })
        }
      })
      // Process Tasks WITH a Dependancy and join back to created array of tasks to get correct id
      this.templateTasks.forEach(task => {
        const docTimestamp = String((new Date()).getTime()) + '-' + Math.floor(Math.random() * 10000) + Math.floor(Math.random() * 10000)
        if (task.after_task) {
          const afterTask = taskList.filter(f => f.taskId === task.after_task)[0]
          taskList.push({ ...task, id: docTimestamp, execution: 'From Task Completion', after_task: afterTask.id })
        }
      })
      // Processing of All Tasks
      // Assigned Users
      taskList.forEach((task, i) => {
        if (task.assignedUsers && task.assignedUsers.length > 0) {
          let assigned = []
          task.assignedUsers.forEach(user => {
            assigned.push(user.id)
          })
          taskList[i].assigned_to = assigned
        }
      })
      // Finding double booked vendors
      taskList.forEach((task, i) => {
        if (task.doubleBookedVendorError && task.doubleBookedVendorError.length > 0) {
          taskList[i].is_double_booked = true
          task.doubleBookedVendorError.forEach(doubleBooked => {
            // this.$store.dispatch('editTask', [{ id: doubleBooked.taskId, is_double_booked: false }])
          })
          delete taskList[i].doubleBookedVendorError
        }
      })
      taskList.map(m => delete m.taskId) // Delete taskId as it is no longer needed
      taskList.map(m => delete m.assignedUsers) // Delete assignedUsers as it is no longer needed
      taskList.map(m => delete m.assigned_names) // Delete assigned_names as it is no longer needed
      taskList.map(m => delete m.displayDays) // Delete displayDays as it is no longer needed
      taskList.map(m => delete m.task_starts) // Delete task_starts as it is no longer needed
      taskList.map(m => delete m.vendorName) // Delete vendorName as it is no longer needed
      taskList.map(m => delete m.vendor_name) // Delete vendorName as it is no longer needed
      const payload = {projectId: this.project.id, projectName: this.project.name, taskTemplate: _.sortBy(taskList, ['order']), startDate: this.projectStartDate, status: this.project.status}
      this.$store.dispatch('buildTaskList', payload)
      this.closeDialog()
    },
    returnDaysDue (props) {
      const vendor = { id: props.item.vendor_id }
      if (props && props.item && props.item.after_task) {
        const afterTask = this.templateTasks.filter(f => f.taskId === props.item.after_task)[0]
        const newOrder = Number(afterTask.order) + Number(props.item.days_due)
        if (props.item.vendor_id) {
          this.checkDoubleBooked(props.index, vendor, newOrder)
        }
        return newOrder
      } else {
        const newOrder = Number(props.item.days_due)
        if (props.item.vendor_id) {
          this.checkDoubleBooked(props.index, vendor, newOrder)
        }
        return newOrder
      }
    },
    updateDaysDueFunction (props) {
      const taskIndex = this.templateTasks.findIndex(i => i.taskId === props.item.taskId)
      this.templateTasks[taskIndex].days_due = this.updateDaysDue
      this.templateTasks[taskIndex].order = this.updateDaysDue
      this.showUpdateDaysDialog = false
      this.updateDaysDue = null
    },
    removeVendor (props) {
      this.templateTasks[props.index].vendorName = 'NO VENDOR ASSIGNED'
      this.templateTasks[props.index].vendor_id = null
      if (this.templateTasks[props.index].doubleBookedVendorError) {
        this.templateTasks[props.index].doubleBookedVendorError = null
        const payload = { removeId: props.index }
        this.$store.commit('getAllDoubleBookedVendors', payload)
      }
    },
    emittedVendor (vendor) {
      const taskIndex = this.templateTasks.findIndex(i => i.taskId === vendor.task.taskId)
      this.templateTasks[taskIndex].vendorName = vendor.name
      this.templateTasks[taskIndex].vendor_id = vendor.id
      this.checkDoubleBooked(taskIndex, vendor)
    },
    updateTaskTemplates (props) {
      console.log('Props', props)
    },
    getTemplateTasks () {
      let taskList = this.$store.getters.getTemplateTasks
      let taskOrder = []
      if (taskList.length > 0) {
        const filteredTasks = taskList.filter(f => f.taskTemplateId === this.selectedTemplate.id && !f.deleted)
        filteredTasks.forEach(task => {
          task.assignedUsers = []
          task.days_due = Number(task.days_due)
          task.order = Number(task.days_due)
          task.displayName = task.name
          task.task_starts = 'From Start Date'
        })
        let tasks = filteredTasks.filter(f => !f.after_task) // Process Tasks Without a Dependancy
        // Set Non-Dependancy Orders
        tasks.forEach(task => {
          taskOrder.push({ id: task.taskId, order: task.days_due })
        })
        tasks = tasks.map(m => ({ ...m, displayName: m.name, after_task: '' }))
        let dependantTaskList = filteredTasks.filter(f => f.after_task) // Process Tasks WITH a Dependancy
        // Loop through Non-Dependancy Hierarchys Adding Downstream orders
        tasks.forEach(task => {
          let dependantTasks = filteredTasks.filter(t => t.after_task === task.taskId)
          while (dependantTasks !== null && dependantTasks.length > 0) {
            let nextDependencies = []
            dependantTasks.forEach(dep => {
              const parentOrder = taskOrder.filter(f => f.id === dep.after_task)[0]
              const orderIdValues = taskOrder.map(m => m.id)
              if (parentOrder && !orderIdValues.includes(dep.taskId)) {
                taskOrder.push({ id: dep.taskId, order: dep.days_due + parentOrder.order })
              }
              let nextDependantTasks = dependantTaskList.filter(t => t.after_task === dep.taskId)
              if (nextDependantTasks && nextDependantTasks.length > 0) {
                nextDependencies = nextDependencies.concat(nextDependantTasks)
              } else {
                dependantTasks = null
              }
            })
            dependantTasks = nextDependencies
          }
        })
        dependantTaskList.forEach((task, i) => {
          const parentTask = filteredTasks.filter(t => t.taskId === task.after_task)[0]
          if (parentTask) {
            task.order = parentTask.order + task.order
            task.task_starts = 'After: ' + parentTask.name
            task.displayName = '-- ' + task.name
            tasks.push(task)
          }
        })
        // Get Vendor Name, Assigned Users, And Order
        tasks.forEach(task => {
          if (task.vendor_id) {
            const vendorList = this.$store.getters.vendorList
            task.vendor_name = vendorList.filter(f => f.id === task.vendor_id)[0].company_name
          }
          if (task.assigned_to && task.assigned_to.length > 0) {
            let assignedUser = []
            task.assigned_to.forEach(assigned => {
              const userList = this.$store.getters.userList
              assignedUser.push(userList.filter(f => f.id === assigned)[0])
            })
            task.assignedUsers = assignedUser
          }
          // Set Order
          const setTaskOrder = taskOrder.filter(f => f.id === task.taskId)[0]
          task.order = setTaskOrder.order
        })
        tasks = tasks.map(m => ({ ...m, displayDays: Math.floor(m.days_due), vendorName: m.vendor_name ? m.vendor_name : 'NO VENDOR ASSIGNED', assigned_names: [] }))
        this.templateTasks = _.orderBy(tasks, ['order', 'name'])
      } else {
        this.templateTasks = []
      }
    },
    save () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data saved'
    },
    cancel () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    open () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    close () {
      console.log('Dialog closed')
    }
  },
  components: {
    VendorSearch,
    Avatar
  }
}
</script>


// WEBPACK FOOTER //
// src/components/projects/ProjectTaskTemplate.vue